module.exports = __webpack_public_path__ + "static/media/dinheiro.b97c300b.svg";